import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";

import "../../../styles/components/utils/components/Rating.scss";
import { ReactComponent as StarIcon } from "../../../styles/images/star_wl.svg";
import starEmpty from "../../../styles/images/starEmpty.svg";

class Rating extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      value: 0,
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    if (this.props.hasOwnProperty("input")) {
      return (
        <div id="rating" className="evio-container input">
          {Array.from({ length: this.state.value }, (_, k) => (
            <StarIcon
              key={"star" + k}
              fill={this.props.brand?.colors?.secondaryColor || "#353841"}
              onClick={() =>
                this.safeSetState(
                  prevState => ({
                    value: prevState.value - (prevState.value - (k + 1)),
                  }),
                  () => this.props.onRatingChange(this.state.value)
                )
              }
            />
          ))}
          {Array.from({ length: 5 - this.state.value }, (_, k) => (
            <img
              key={"empty" + k}
              src={starEmpty}
              alt=""
              onClick={() =>
                this.safeSetState(
                  prevState => ({ value: prevState.value + k + 1 }),
                  () => this.props.onRatingChange(this.state.value)
                )
              }
            />
          ))}
          <button
            className="clearBt"
            onClick={() =>
              this.safeSetState(
                prevState => ({
                  value: prevState.value - prevState.value,
                }),
                () => this.props.onRatingChange(this.state.value)
              )
            }
          >
            <Translate value={`mapFilter_ratingClearBt`} />
          </button>
        </div>
      );
    } else
      return (
        <div id="rating" className="evio-container">
          {Array.from({ length: this.props.value }, (_, k) => (
            <StarIcon
              key={"star" + k}
              fill={this.props.brand?.colors?.secondaryColor || "#353841"}
            />
          ))}
          {Array.from({ length: 5 - this.props.value }, (_, k) => (
            <img key={"empty" + k} src={starEmpty} alt="" />
          ))}
        </div>
      );
  }
}

const mapStateToProps = state => ({
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(Rating);
